import {Router} from "../../../../stem-core/ui/Router.jsx";
import {ADDRESS_PANEL_URL} from "../../PanelConstants.js";
import {UserAddress} from "../../../../client/state/UserAddressStore.js";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService.js";
import {BaseFlowStep} from "./BaseFlowStep.jsx";


export class AddressFlowStep extends BaseFlowStep {
    haveOptionsAvailable() {
        return this.selectedValue || iFrameUserDataService.getExtraUserAddressCount();
    }

    getDefaultFields() {
        this.selectedValue = UserAddress.getDefault();
    }

    showPanel() {
        Router.changeURL(ADDRESS_PANEL_URL);
    }
}
